import { useEffect } from "react";
// import EventSource from "eventsource";
import { useKeycloak } from "@react-keycloak/web";
import { emitter } from "./Util";
import config from "../config/index";
import { createUpdateNotification } from "../services/apis";

const GlobalEventListener = () => {
  const { keycloak } = useKeycloak();
  const saveNotification = (payload) => {
    createUpdateNotification(payload, (err, data) => {
      if (err) {
        console.log(err.message || "Error in create or updating notification");
      } else {
        console.log("sucessfully created or updated notification");
      }
    });
  };
  useEffect(() => {
    if (!keycloak.token) {
      return;
    }
    const globalEventListenerBaseUrl =
      config.globalEventListener || config.globalEventListenerUrl;
    if (!globalEventListenerBaseUrl) {
      console.error("Global event listener URL is not configured.");
      return;
    }
    const resourceUrl = `${globalEventListenerBaseUrl}${encodeURIComponent(keycloak.token)}`;
    // const resourceUrl = `${config.globalEventListenerUrl}${encodeURIComponent(keycloak.token)}`;
    // const eventSourceInitDict = {
    //   https: { rejectUnauthorized: false },
    //   headers: { withCredentials: true },
    // };
    // const source = new EventSource(resoureUrl, eventSourceInitDict);

    // ✅ Use native browser EventSource
    const source = new window.EventSource(resourceUrl);

    source.onmessage = (e) => {
      if (
        e.data &&
        e.data !== "Subscription confirmed" &&
        !e.data.includes("heartbeat")
      ) {
        try {
          const parsedData = JSON.parse(e.data);
          if (parsedData.mlrStatus === "Expired") {
            let notificationObj = {
              documentNumber: parsedData.damDocNumber,
              documentId: parsedData.damDocId,
              expiredAt: parsedData.timeStamp.replace(" ", "T") + ":00.000Z",
              status: parsedData.mlrStatus,
              title: parsedData.type + " Expired",
              type: parsedData.type + "s",
              updateType: "createNewNotification",
            };
            saveNotification(notificationObj);
          }
          emitter.emit("autoSync", parsedData);
        } catch (error) {
          console.error("Failed to parse MLR event data:", error);
        }
      }
    };

    source.onerror = function (err) {
      if (err) {
        if (err.status === 401 || err.status === 403) {
          console.log("not authorized");
        }
      }
    };

    return () => {
      source.close();
    };
  }, [keycloak.token]);
  return null;
};
export default GlobalEventListener;

// import { useEffect } from "react";
// import EventSource from "eventsource";
// import { useKeycloak } from "@react-keycloak/web";
// import { emitter } from "./Util";
// import { createUpdateNotification } from "../services/apis";
// const GlobalEventListener = () => {
//   const { keycloak } = useKeycloak();
//   const saveNotification = (payload) => {

//     createUpdateNotification(payload, (err, data) => {
//       if (err) {
//         console.log(err.message || 'Error in create or updating notification');
//       } else {
//         console.log("sucessfully created or updated notification");
//       }
//     });
//   };
//   useEffect(() => {
//     if (!keycloak.token) {
//       return;
//     }
//     const resoureUrl = `https://nccabanner-api-gilead-dev.indegene.com/api/contentms/v1/mlrStatusPush?token=${encodeURIComponent(
//       keycloak.token
//     )}`;
//     const eventSourceInitDict = {
//       https: { rejectUnauthorized: false },
//       headers: { withCredentials: true },
//     };
//     const source = new EventSource(resoureUrl, eventSourceInitDict);

//     source.onmessage = (e) => {
//       if (
//         e.data &&
//         e.data !== "Subscription confirmed" &&
//         !e.data.includes("heartbeat")
//       ) {
//         try {
//           const parsedData = JSON.parse(e.data);
//           if(parsedData.mlrStatus==='Expired'){
//            let notificationObj = {
//                 documentNumber: parsedData.damDocNumber,
//                 documentId: parsedData.damDocId,
//                 expiredAt: parsedData.timeStamp.replace(' ', 'T') + ':00.000Z',
//                 status: parsedData.mlrStatus,
//                 title: parsedData.type+' Expired',
//                 type: parsedData.type+'s',
//                 updateType: 'createNewNotification'
//             }
//           saveNotification(notificationObj);
//           }
//           emitter.emit("autoSync", parsedData);
//         } catch (error) {
//           console.error("Failed to parse MLR event data:", error);
//         }
//       }
//     };

//     source.onerror = function (err) {
//       if (err) {
//         if (err.status === 401 || err.status === 403) {
//           console.log("not authorized");
//         }
//       }
//     };

//     return () => {
//       source.close();
//       emitter.off("autoSync");
//     };
//   }, []);
//   return null;
// };
// export default GlobalEventListener;
